<cbc-container [isLoading]="isLoading" [showContainer]="true" title="Perguntas Frequentes">
</cbc-container> 
<div class="container" [class.is_mobile]="isMobile">
  <div class="faq-container">

    @if (isLoading) {
      <div class="empty-state">
        <p class="text-secondary">Carregando perguntas frequentes...</p>
      </div>
    } @else if (faqGroups.length === 0) {
      <div class="empty-state">
        <p class="text-secondary">Nenhuma pergunta frequente disponível no momento.</p>
      </div>
    } @else {
      @for (group of faqGroups; track group.groupName) {
        <div class="card faq-group">
          <div class="card-header">
            <h3 class="card-title">{{ group.groupName }}</h3>
          </div>
          <div class="card-body">
            <mat-accordion>
              @for (faq of group.faqs; track faq.id) {
                <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                  <mat-expansion-panel-header>
                    <mat-panel-title>{{ faq.question }}</mat-panel-title>
                  </mat-expansion-panel-header>
                  <p class="faq-response">{{ faq.response }}</p>
                  @if (faq.link) {
                    <a [routerLink]="faq.link" class="faq-link">
                      <mat-icon>arrow_forward</mat-icon>
                      {{ faq.labellink ?? '' }}
                    </a>
                  }
                </mat-expansion-panel>
              }
            </mat-accordion>
          </div>
        </div>
      }
    }

  </div>
</div>
